import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
export function PopularRoutes() {
  const {
    language
  } = useLanguage();
  const content = {
    en: {
      title: 'Popular routes in Ibiza',
      subtitle: 'Fixed price · No surprises',
      routes: [{
        name: 'Ibiza Airport to Ibiza Town',
        price: 'From €120'
      }, {
        name: "Ibiza Airport to Playa d'en Bossa",
        price: 'From €100'
      }, {
        name: 'Ibiza Airport to San Antonio',
        price: 'From €120'
      }, {
        name: 'Ibiza Airport to Santa Eulalia',
        price: 'From €140'
      }, {
        name: 'Ibiza Airport to San José',
        price: 'From €120'
      }, {
        name: 'Ibiza Airport to Cala Jondal',
        price: 'From €100'
      }],
      supportText: 'We also provide transfers to villas, hotels, marinas, restaurants, beach clubs and private events across Ibiza.',
      getQuote: 'Book on WhatsApp',
      customRoute: "Don't see your route? Send us your details"
    },
    es: {
      title: 'Rutas populares en Ibiza',
      subtitle: 'Precio fijo · Sin sorpresas',
      routes: [{
        name: 'Aeropuerto de Ibiza a Ibiza Town',
        price: 'Desde €120'
      }, {
        name: "Aeropuerto de Ibiza a Playa d'en Bossa",
        price: 'Desde €100'
      }, {
        name: 'Aeropuerto de Ibiza a San Antonio',
        price: 'Desde €120'
      }, {
        name: 'Aeropuerto de Ibiza a Santa Eulalia',
        price: 'Desde €140'
      }, {
        name: 'Aeropuerto de Ibiza a San José',
        price: 'Desde €120'
      }, {
        name: 'Aeropuerto de Ibiza a Cala Jondal',
        price: 'Desde €100'
      }],
      supportText: 'También ofrecemos traslados a villas, hoteles, marinas, restaurantes, beach clubs y eventos privados en toda Ibiza.',
      getQuote: 'Reservar por WhatsApp',
      customRoute: '¿No ves tu ruta? Envíanos tus datos'
    }
  };
  const {
    title,
    subtitle,
    routes,
    supportText,
    getQuote,
    customRoute
  } = content[language];
  const handleRouteClick = (routeName: string) => {
    const text = language === 'en' ? `Hello, I'd like a quote for the route: ${routeName}` : `Hola, me gustaría pedir precio para la ruta: ${routeName}`;
    window.open(`https://wa.me/34613756211?text=${encodeURIComponent(text)}`, '_blank');
  };
  const handleCustomRoute = () => {
    const text = language === 'en' ? `Hello, I need a custom transfer quote in Ibiza.` : `Hola, necesito un presupuesto de traslado personalizado en Ibiza.`;
    window.open(`https://wa.me/34613756211?text=${encodeURIComponent(text)}`, '_blank');
  };
  return <section className="py-14 md:py-28 bg-white" data-id="element-199">
      <div className="mx-auto max-w-7xl px-5" data-id="element-200">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="text-center mb-10 md:mb-16" data-id="element-201">
          <span className="block text-xs font-semibold tracking-wider text-navy/60 uppercase mb-3" data-id="element-202">
            {subtitle}
          </span>
          <h2 className="text-3xl md:text-4xl font-heading text-navy mb-4" data-id="element-203">
            {title}
          </h2>
          <div className="w-12 h-px bg-gold-subtle/50 mx-auto" data-id="element-204" />
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-10" data-id="element-205">
          {routes.map((route, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} onClick={() => handleRouteClick(route.name)} className="group flex flex-col justify-center px-5 py-5 rounded-xl bg-warm-white border border-stone/10 hover:border-gold-subtle/40 hover:shadow-md transition-all cursor-pointer" data-id="element-206">
              <div className="flex items-start justify-between mb-3" data-id="element-207">
                <div className="flex items-start space-x-3 pr-4" data-id="element-208">
                  <MapPinIcon className="w-5 h-5 text-gold-subtle flex-shrink-0 mt-0.5" data-id="element-209" />
                  <span className="text-base font-semibold text-navy leading-tight" data-id="element-210">
                    {route.name}
                  </span>
                </div>
                <span className="text-sm font-bold text-navy bg-stone/5 px-2 py-1 rounded whitespace-nowrap" data-id="element-211">
                  {route.price}
                </span>
              </div>
              <div className="flex items-center space-x-1.5 text-sm font-medium text-whatsapp group-hover:text-whatsapp-hover transition-colors ml-8" data-id="element-212">
                <span data-id="element-213">{getQuote}</span>
                <ArrowRightIcon className="w-3.5 h-3.5" data-id="element-214" />
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-215">
          <button onClick={handleCustomRoute} className="inline-flex items-center space-x-2 text-sm font-medium text-navy hover:text-gold-subtle transition-colors mb-6" data-id="element-216">
            <span data-id="element-217">{customRoute}</span>
            <ArrowRightIcon className="w-4 h-4" data-id="element-218" />
          </button>

          <p className="text-slate text-sm max-w-2xl mx-auto leading-relaxed" data-id="element-219">
            {supportText}
          </p>
        </div>
      </div>
    </section>;
}